// Copyright (c) 2022 by Move Closer

import { DropdownItemProps } from './DropdownItem/DropdownItem.contracts'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export interface DropdownConfig {
  /**
   * Offset from top of the element.
   */
  offset: string
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export enum DropdownPlacement {
  DownStart = 'down-start',
  DownEnd = 'down-end',
  UpStart = 'up-start',
  UpEnd = 'up-end',
}

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export interface DropdownProps {
  /**
   * Configuration for dropdown
   */
  config: DropdownConfig

  /**
   * Custom classes
   */
  dropdownClasses?: Array<string>

  /**
   * DropdownItems.
   */
  items: DropdownItemProps[]

  /**
   * Label for the trigger button
   */
  label: string

  /**
   * Placement of the box.
   */
  placement: string

  container?: string
}
